import standardAPI from '@/api/standard_items';

const state = {
  seo: [],
  seo_status: '',
  seo_MetaData: {},
  seo_page: 1,
  seo_perPage: 10,
};

const responseUrl = '/seo';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_seo ({ commit }, getOptions) {
    commit('SEO_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('SEO_SUCCESS', response);
            commit('SEO_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('SEO_READY');
            reject(response);
          } else {
            commit('SEO_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_seo_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_seo ({ commit, dispatch }, itemData) {
    commit('SEO_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('SEO_READY');
          resolve(response);
        } else {
          commit('SEO_READY');
          reject(response);
        }
      });
    });
  },
  edit_seo ({ commit, dispatch }, itemData) {
    commit('SEO_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('SEO_READY');
          resolve(response);
        } else {
          commit('SEO_READY');
          reject(response);
        }
      });
    });
  },
  remove_seo ({ commit, dispatch }, itemData) {
    commit('SEO_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('SEO_READY');
          resolve(response);
        } else {
          commit('SEO_READY');
          reject(response);
        }
      });
    });
  },
  reorder_seo ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.seo_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.seo_perPage = max;
  },
  SEO_READY: (state) => {
    state.seo_status = 'ready';
  },
  SEO_REQUEST: (state) => {
    state.seo_status = 'loading';
  },
  SEO_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.seo_MetaData.meta = response.meta;
      state.seo_MetaData.links = response.links;
    }
    state.seo = response.data;
    state.seo_status = 'success';
  },
  SEO_ERROR: (state) => {
    state.seo_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
